export default __webpack_public_path__ + "static/card-ios-29073f7c439e2186f8668f4f35a5c916.png";